/* Shared catalogue helpers. Product and Tattoo Book filters use the same tags. */
(() => {
  if (window.AltreArtwork) return;
  const categories = value => {
    const result = new Map();
    String(value || '').split(',').forEach(part => {
      const label = part.trim();
      if (label && !result.has(label.toLowerCase())) result.set(label.toLowerCase(), label);
    });
    return [...result].map(([key, label]) => ({ key, label }));
  };
  const matches = (tile, filter) => filter === '*' || (filter === '@featured'
    ? tile.dataset.featured === 'true'
    : categories(tile.dataset.category).some(category => `category:${category.key}` === filter));
  const filters = (tiles, featuredFirst = false) => {
    const options = [['All designs', '*']];
    if (tiles.some(tile => tile.dataset.featured === 'true')) options[featuredFirst ? 'unshift' : 'push'](['Popular', '@featured']);
    const tags = new Map();
    tiles.forEach(tile => categories(tile.dataset.category).forEach(category => {
      if (!tags.has(category.key)) tags.set(category.key, category.label);
    }));
    tags.forEach((label, key) => options.push([label, `category:${key}`]));
    return options;
  };
  const sources = () => [...document.querySelectorAll('template[data-altre-library]')];
  const source = () => sources().find(item => item.dataset.productUrl) || sources()[0];
  const tiles = () => sources().flatMap(item => [...item.content.querySelectorAll('[data-sk-design]')].map(tile => tile.cloneNode(true)));
  const storageKey = 'altre_design_shortlist_v1';
  const shortlist = () => {
    try { return [...new Set(JSON.parse(localStorage.getItem(storageKey)) || [])].filter(Boolean).slice(0, 5); }
    catch (_) { return []; }
  };
  const saveShortlist = ids => {
    const clean = [...new Set(ids)].filter(Boolean).slice(0, 5);
    try { localStorage.setItem(storageKey, JSON.stringify(clean)); } catch (_) {}
    document.dispatchEvent(new CustomEvent('altre:shortlist-change', { detail: { ids: clean } }));
    return clean;
  };
  const toggleShortlist = id => {
    const ids = shortlist();
    const index = ids.indexOf(id);
    if (index >= 0) { ids.splice(index, 1); return { ids: saveShortlist(ids), added: false, full: false }; }
    if (ids.length >= 5) return { ids, added: false, full: true };
    ids.push(id); return { ids: saveShortlist(ids), added: true, full: false };
  };
  const removeShortlist = id => saveShortlist(shortlist().filter(item => item !== id));
  window.AltreArtwork = Object.freeze({ categories, matches, filters, source, tiles, shortlist, toggleShortlist, removeShortlist });
})();
